/** Логотип «trendator» с неоновой точкой (docs/design/LogoT.dc.html). */
export function Wordmark({ size = 26 }: { size?: number }) {
  return (
    <span className="wordmark" style={{ fontSize: size }} aria-label="Trendator">
      trendator
      <span className="wordmark__dot" aria-hidden="true" />
    </span>
  );
}
